import React, { useState, useEffect } from "react";
import { Modal, Tooltip, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import WidgetList from "./WidgetList";

const createModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80%",
  overflowX: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  "& .MuiFormHelperText-root": { color: "#d32f2f" },
  borderRadius: "0.5rem",
};

function WidgetDashboardModal({
  open,
  handleClose,
  user,
  widgets,
  widgetDefinitions,
  handleSave,
  handleDeleteUserDashboard,
  handleSaveCompanyDefault,
  handleDeleteCompanyDashboard,
}) {
  const [widgetList, setWidgetList] = useState(widgets);

  useEffect(() => {
    setWidgetList(widgets);
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <MDBox
        sx={{
          ...createModalStyle,
          width: {
            xs: "90%",
            md: "700px",
          },
        }}
      >
        <MDTypography
          sx={{ marginBottom: "2rem" }}
          id="modal-modal-title"
          variant="h5"
          component="h2"
        >
          Customize Widget Dashboard
        </MDTypography>
        <MDBox>
          <WidgetList
            widgets={widgetList}
            widgetDefinitions={widgetDefinitions}
            setWidgetList={setWidgetList}
          />
        </MDBox>
        <Divider variant="middle" />
        {user.userPermission?.admin && (
          <MDBox sx={{ display: "flex" }}>
            <Tooltip title="Saves your current dashboard as your company default (Admin privileges only)">
              <MDButton
                variant="outlined"
                color="gray80"
                sx={{ mt: 2, mr: 1, position: "relative" }}
                onClick={() => {
                  handleSaveCompanyDefault(widgetList);
                  handleClose();
                }}
              >
                Save as company default
              </MDButton>
            </Tooltip>
            <Tooltip title="Delete your company-specific dashboard (Admin privileges only)">
              <MDButton
                variant="outlined"
                color="gray80"
                sx={{ mt: 2, mr: 1, position: "relative" }}
                onClick={() => {
                  handleDeleteCompanyDashboard();
                  handleClose();
                }}
              >
                Delete company default
              </MDButton>
            </Tooltip>
          </MDBox>
        )}
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <MDBox>
            <Tooltip title="Delete your user-specific dashboard. The dashboard will default to your company-specific (if available) or Alysio default layout">
              <MDButton
                variant="outlined"
                color="primaryRed"
                sx={{
                  mt: {
                    xs: 1,
                    sm: 2,
                  },
                  mr: 1,
                  position: "relative",
                }}
                onClick={() => {
                  handleDeleteUserDashboard();
                  handleClose();
                }}
              >
                Delete your dashboard
              </MDButton>
            </Tooltip>
          </MDBox>
          <MDBox>
            <MDButton
              color="gray80"
              onClick={handleClose}
              sx={{
                mt: {
                  xs: 1,
                  sm: 2,
                },
                mr: 1,
                position: "relative",
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              color="primaryRed"
              onClick={() => {
                handleSave(widgetList);
                handleClose();
              }}
              sx={{
                mt: {
                  xs: 1,
                  sm: 2,
                },
                width: "95px",
                mr: 1,
                position: "relative",
              }}
            >
              Save
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default WidgetDashboardModal;
